import React from 'react';
import PropTypes from 'prop-types';
import MuiPaper from '@mui/material/Paper';
import { sxPropType } from '../../proptypes/misc';

function Paper({ sx, background, padding, ...other }) {
  return (
    <MuiPaper
      elevation={0}
      square={false}
      sx={[
        background === 'dark'
          ? (theme) => ({
              backgroundColor: theme.palette.background.default,
            })
          : (theme) => ({
              color: theme.palette.text.secondary,
              backgroundColor: theme.palette.background.paper,
            }),
        padding &&
          ((theme) => ({
            padding: theme.spacing(1),
          })),
        {
          borderRadius: '25px',
          overflow: 'hidden',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    />
  );
}

Paper.propTypes = {
  sx: sxPropType,
  background: PropTypes.oneOf(['default', 'dark']),
  padding: PropTypes.bool,
};

Paper.defaultProps = {
  sx: [],
  background: 'default',
  padding: false,
};

export default Paper;
